
import { supabase } from "@/integrations/supabase/client";
import { Interview } from "@/types/interview";
import { InterviewMapperService } from "../base/interviewMapperService";

/**
 * Service for fetching pending interviews
 */
export class PendingInterviewsService {
  /**
   * Fetch all pending interviews
   */
  static async getPendingInterviews(): Promise<Interview[]> {
    console.log('Fetching pending interviews');
    const { data, error } = await supabase
      .from('interviews')
      .select('*')
      .eq('publication_status', 'pending' as any)
      .eq('is_in_feeder', false as any) // Only get non-feeder interviews
      .order('timestamp', { ascending: false });

    if (error) {
      console.error('Error fetching pending interviews:', error);
      throw new Error(`Failed to fetch pending interviews: ${error.message}`);
    }

    console.log(`Found ${data?.length || 0} pending interviews`);
    return data?.map(interview => InterviewMapperService.mapDatabaseInterviewToModel(interview as any)) || [];
  }

  /**
   * Get a single interview by ID
   */
  static async getInterviewById(interviewId: string): Promise<Interview | null> {
    console.log('Fetching interview by ID:', interviewId);
    const { data, error } = await supabase
      .from('interviews')
      .select('*')
      .eq('id', interviewId as any)
      .maybeSingle();

    if (error) {
      console.error('Error fetching interview:', error);
      throw new Error(`Failed to fetch interview: ${error.message}`);
    }

    if (!data) return null;

    console.log('Interview found:', (data as any)?.id);
    return InterviewMapperService.mapDatabaseInterviewToModel(data as any);
  }
}
